/**
 * Utility functions for status messages
 */

/**
 * Wählt eine zufällige Nachricht aus einem Array
 * @param {string[]} messages - Array mit Message-Optionen
 * @returns {string} Zufällige Message
 */
export function pickRandom(messages) {
  if (!messages || messages.length === 0) return '';
  return messages[Math.floor(Math.random() * messages.length)];
}

/**
 * Ersetzt Platzhalter in einer Nachricht
 * @param {string} message - Message mit {placeholder} Syntax
 * @param {Object} data - Key-Value Pairs für Ersetzungen
 * @returns {string} Message mit ersetzten Platzhaltern
 */
export function fillPlaceholders(message, data = {}) {
  if (!message) return '';
  let result = message;
  Object.keys(data).forEach(key => {
    result = result.replace(new RegExp(`\\{${key}\\}`, 'g'), data[key]);
  });
  return result;
}

/**
 * Kombiniert pickRandom und fillPlaceholders
 * @param {string[]} messages - Array mit Message-Optionen
 * @param {Object} data - Placeholder-Daten
 * @returns {string} Fertige Message
 */
export function getMessage(messages, data = {}) {
  return fillPlaceholders(pickRandom(messages), data);
}

/**
 * Formatiert eine Kartenbeschreibung für Anzeige
 * @param {Object} card - Karten-Objekt mit rank/suit
 * @returns {string} Formatierte Beschreibung
 */
export function formatCard(card) {
  if (!card) return '';
  const rankNames = {
    '2': '2', '3': '3', '4': '4', '5': '5', '6': '6',
    '7': '7', '8': '8', '9': '9', '10': '10',
    'J': 'Bube', 'Q': 'Dame', 'K': 'König', 'A': 'Ass'
  };
  const suitEmojis = {
    'hearts': '♥', 'diamonds': '♦', 'clubs': '♣', 'spades': '♠'
  };
  return `${rankNames[card.rank] || card.rank}${suitEmojis[card.suit] || ''}`;
}

/**
 * Formatiert mehrere Karten für Anzeige
 * @param {Object[]} cards - Array von Karten-Objekten
 * @returns {string} Formatierte Beschreibung
 */
export function formatCards(cards) {
  if (!cards || cards.length === 0) return '';
  if (cards.length === 1) return formatCard(cards[0]);
  return cards.map(formatCard).join(', ');
}

/**
 * Gibt Kombinationstyp-Namen zurück
 * @param {string} type - Kombinationstyp
 * @param {number} size - Anzahl Karten
 * @returns {string} Beschreibung
 */
export function formatPlayType(type, size) {
  const typeNames = {
    'single': 'Single',
    'pair': 'Paar',
    'triple': 'Drilling',
    'quad': 'Vierling',
    'twoPair': 'Zwei Paare',
    'straight': 'Straße',
    'flush': 'Flush',
    'fullHouse': 'Full House',
    'straightFlush': 'Straight Flush',
    'royalFlush': 'Royal Flush'
  };

  if (type === 'quad' || size >= 4) return 'Bombe';
  return typeNames[type] || type;
}
